import { render } from "./WhatsAppConfiguration.vue?vue&type=template&id=6db2235f&scoped=true"
import script from "./WhatsAppConfiguration.vue?vue&type=script&lang=js"
export * from "./WhatsAppConfiguration.vue?vue&type=script&lang=js"

import "./WhatsAppConfiguration.vue?vue&type=style&index=0&id=6db2235f&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db2235f"]])

export default __exports__